import MainPage from "./decay_sim_main";
import DownloadPage from "./decay_sim_download";
import {Images} from "../../AssetReferences";

export class Pages
{
    static Main = 1;
    static Download = 2;
}

export class Media
{
    static BackgroundVideo = "./george/tileable_backgrounds/tileable_background_white.mp4";
    static FrameIcon = "./george/frame_icon.gif";
    
   
    
    static DownloadIcon = Images.George;
    
    static DecaySimTitle = "./george/decaysim_title.png";

    static Quickstart1 = "./george/quickstart_images/quickstart_1.png";
    static Quickstart2 = "./george/quickstart_images/quickstart_2.png";
    static Quickstart3 = "./george/quickstart_images/quickstart_3.png";
    
    static Examples1 = "./george/examples/examples_1.png";
    static Examples2 = "./george/examples/examples_2.png";
    static Examples3 = "./george/examples/examples_3.png";
}

export class Download
{
    static Mac = "./decay_sim/DecaySimMac.zip"
    static Windows = "./decay_sim/DecaySimWindows.zip"
}